export default __webpack_public_path__ + "static/media/arkguide_08.1488dcb8.gif";